<div class="ui-day-strip">
  <div class="ui-day-strip__header">
    <button
      type="button"
      class="ui-day-strip__nav"
      aria-label="Semana anterior"
      (click)="prev()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M15 18l-6-6 6-6" />
      </svg>
    </button>

    <span class="ui-day-strip__month">{{ headerLabel() }}</span>

    <button
      type="button"
      class="ui-day-strip__nav"
      aria-label="Semana siguiente"
      (click)="next()"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M9 18l6-6-6-6" />
      </svg>
    </button>
  </div>

  <div class="ui-day-strip__days" role="group" aria-label="Seleccionar día">
    @for (day of visibleDays(); track day.getTime()) {
      <button
        type="button"
        class="ui-day-strip__day"
        [class.ui-day-strip__day--selected]="isSelected(day)"
        [class.ui-day-strip__day--today]="isToday(day) && !isSelected(day)"
        [attr.aria-pressed]="isSelected(day)"
        [attr.aria-label]="dayName(day) + ' ' + dayNumber(day)"
        (click)="select(day)"
      >
        <span class="ui-day-strip__day-name">{{ dayName(day) }}</span>
        <span class="ui-day-strip__day-num">{{ dayNumber(day) }}</span>
      </button>
    }
  </div>
</div>
